// SELECT SIZE TXT & DISABLE ADD TO CART ON PAGE LOAD

$(document).ready(function() {
    function checkSizeVariant(root = document) {
      $(root).find('.product-info__block-list').each(function() {
        const productInfo = $(this);
        if (!productInfo.find('.option_downcase-size').length) return;

        const form = productInfo.find('form[action="/cart/add"]').first();
        if (!form.length || form[0].dataset.sizeOptionChosen === 'true') return;
        const addToCartButton = form.find('button.button');
        // Required-selection and sold-out PDP buttons already have their own
        // disabled state and label. The legacy Size guard is for quick buy.
        if (addToCartButton.prop('disabled')) return;
        const selectedVariantId = form.find('input[name="id"]').val();
        const requestedVariantId = new URLSearchParams(window.location.search).get('variant');

        // A valid variant deep link is an explicit size choice. Do not let this
        // legacy guard swallow the first add-to-cart click on Merchant links.
        if (productInfo.find('variant-picker[update-url]').length && requestedVariantId && selectedVariantId === requestedVariantId && !addToCartButton.prop('disabled')) {
          addToCartButton.removeClass('select_size_btn');
          productInfo.find('.option_downcase-size').removeClass('disabled_selected_block');
          return;
        }

        addToCartButton.addClass('select_size_btn');
        addToCartButton.text(window.themeVariables.strings.selectSize);
        productInfo.find('.option_downcase-size').addClass('disabled_selected_block');
      });
    }
    checkSizeVariant();

  $(document).on('click', '.product-card__quick-add-button[aria-controls]', function() {
    const modal = document.getElementById(this.getAttribute('aria-controls'));
    modal?.addEventListener('dialog:before-show', () => checkSizeVariant(modal), { once: true });
    // The picker can finish loading before the modal is attached to document.
    modal?.addEventListener('variant:loaded', () => checkSizeVariant(modal), { once: true });
  });
});

$(document).on('click', '.option_downcase-size label', function(){
  const radio = this.control;
  if (!radio || radio.disabled || !radio.form?.matches('form[action="/cart/add"]')) return;

  radio.form.dataset.sizeOptionChosen = 'true';
  const productInfo = $(this).closest('.product-info__block-list');
  const addToCartButton = $(radio.form).find('button.button');
  if (!addToCartButton.prop('disabled')) {
    addToCartButton.removeClass('select_size_btn');
    addToCartButton.text(window.themeVariables.strings.addToCartButton);
  }
  productInfo.find('.option_downcase-size').removeClass('disabled_selected_block');
});

// Keyboard activation clicks the radio itself, without clicking its label.
// Remember that this form's size was chosen before the picker emits variant:change.
document.addEventListener('click', function(event) {
  const dropdownOption = event.target.closest?.('.option_downcase-size x-listbox [data-option-value]');
  if (event.isTrusted && dropdownOption && !dropdownOption.disabled && dropdownOption.getAttribute('aria-disabled') !== 'true') {
    const picker = dropdownOption.closest('variant-picker');
    const dropdownForm = document.forms[picker?.getAttribute('form')];
    if (dropdownForm?.matches('form[action="/cart/add"]')) {
      dropdownForm.dataset.sizeOptionChosen = 'true';
      const button = dropdownForm.querySelector('button.button');
      if (button && !button.disabled) {
        button.classList.remove('select_size_btn');
        button.textContent = window.themeVariables.strings.addToCartButton;
      }
      dropdownForm.closest('.product-info__block-list')?.querySelector('.option_downcase-size')?.classList.remove('disabled_selected_block');
    }
    return;
  }

  const radio = event.target;
  if (!event.isTrusted || !radio?.matches?.('.option_downcase-size input[type="radio"]') || radio.disabled) return;

  const form = radio.form;
  if (!form?.matches?.('form[action="/cart/add"]')) return;
  form.dataset.sizeOptionChosen = 'true';
  const button = form.querySelector('button.button');
  if (button && !button.disabled) {
    button.classList.remove('select_size_btn');
    button.textContent = window.themeVariables.strings.addToCartButton;
  }
  form.closest('.product-info__block-list')?.querySelector('.option_downcase-size')?.classList.remove('disabled_selected_block');
}, true);

// A PDP completion clears the guard; URL-disabled quick buy still requires an
// explicit Size action, even when changing another option produces a variant.
document.addEventListener('variant:change', function(event) {
  const form = event.target;
  if (!event.detail?.variant?.available || !form?.matches?.('form[action="/cart/add"]')) return;

  const productInfo = form.closest('.product-info__block-list');
  if (!productInfo?.querySelector('.option_downcase-size')) return;
  const picker = Array.from(productInfo.querySelectorAll('variant-picker')).find((candidate) => candidate.getAttribute('form') === form.getAttribute('id'));
  if (!picker?.hasAttribute('update-url') && form.dataset.sizeOptionChosen !== 'true') return;

  form.querySelector('button.button')?.classList.remove('select_size_btn');
  productInfo.querySelector('.option_downcase-size')?.classList.remove('disabled_selected_block');
}, true);

$(document).on('click', '.select_size_btn', function(e){
  e.preventDefault();
  e.stopPropagation();
});


// Expand Cart Note

$("#gift-checkbox").click(function(){
$("textarea#cartSpecialInstructions").toggle();
});

// Footer Accordion Mobile
$('.accordionnn').click(function(){
    if ($(window).width() <= 767) {
        $(this).toggleClass('up');
        $(this).siblings('.panell').slideToggle('fast');
    }
});
// Main Categories Menu Above the Logo (mobile/tablet)
if (window.location.href.indexOf("kids") > -1 || window.location.href.indexOf("boys") > -1 || window.location.href.indexOf("mini-me-collection")  > -1) {
    jQuery('body').addClass('kids-section');
    jQuery(".nav-main-mobile #men-section").removeClass("active");
    jQuery(".nav-main-mobile #kids-section").addClass("active");
    $('.header__logo-image').attr('src', 'https://cdn.shopify.com/s/files/1/1150/4428/files/JCKidsLogo.png');
    $('.header__logo-image').attr('srcset', 'https://cdn.shopify.com/s/files/1/1150/4428/files/JCKidsLogo.png');
  
}  else if (window.location.href.indexOf("women") > -1){
    jQuery('body').addClass('women-section');
    jQuery(".nav-main-mobile #men-section").removeClass("active");
    jQuery(".nav-main-mobile #women-section").addClass("active");
    $('.header__logo-image').attr('src', 'https://cdn.shopify.com/s/files/1/1150/4428/files/JCWomenLogo.png');
    $('.header__logo-image').attr('srcset', 'https://cdn.shopify.com/s/files/1/1150/4428/files/JCWomenLogo.png');
    
}  else if (window.location.href.indexOf("big-men") > -1){
   jQuery('body').addClass('big-mens-section');
   jQuery(".nav-main-mobile #men-section").removeClass("active");
   jQuery(".nav-main-mobile #bigmens-section").addClass("active");
   $('.header__logo-image').attr('src', 'https://cdn.shopify.com/s/files/1/1150/4428/files/JCBigMenLogo.png');
   $('.header__logo-image').attr('srcset', 'https://cdn.shopify.com/s/files/1/1150/4428/files/JCBigMenLogo.png');


} else {
    jQuery('body').addClass('mens-section');
    jQuery('.header-logo-fix > a').attr("data-site", "mens").attr("href", "/");
    jQuery('.header-logo-fix img').attr("src", "//cdn.shopify.com/s/files/1/1150/4428/files/logo-jcmen.png");
} 
